var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 34.498V24.431c0-1.103 1.176-1.79 2.112-1.235l8.593 5.034 8.593 5.034c.936.548.936 1.928 0 2.476l-8.593 5.033-8.593 5.034c-.936.548-2.112-.138-2.112-1.234V34.498"
  })));
};
export default SvgPlay;